import { createMuiTheme } from '@material-ui/core/styles';
import { green, red } from '@material-ui/core/colors';
import createBreakpoints from '@material-ui/core/styles/createBreakpoints'

const breakpoints = createBreakpoints({})

const theme = createMuiTheme({
  
    overrides: {

      MuiStepper: {
        root:{
            paddingLeft: 0,
            paddingRight: 0,
        },
    },

    MuiStepButton: {
      root: {
        width: '50%',
      },
    },

       MuiButton: { 
          
          root: {
                textTransform: 'none',
                marginTop: 10,
                disableElevation: 0,
                
            }, 
             iconSizeMedium: {
        "& > *:first-child": {
          fontSize: 24
        },

      },  

        },

  
        MuiTab: {
          root: {
            textAlign: 'left',
            justifyContent: 'flex-start',
            alignItems: 'flex-start',
            paddingLeft: 0,
        },
      },  
      MuiBox: {
        padding: 0,
      },

      MuiTabs: {
        root: {
          textAlign: 'left',
      },
    },  
  },
  MuiButton: {
    disableElevation: true,
    height: '100%',
  },



    palette: {
    primary: {
      light: '#DE6464',
      main: '#B64C4C',
      dark: '#933A3A',
      contrastText: '#ffffff',
    },

    colorTextSecondary: {
      color: 'white',
    },

    link: {
      main: '#B64C4C',
    },
   
    secondary: {
      light: '#fff5f8',
      main: '#555263',
      dark: '#e62958',
    },
    warning: {
      main: '#ffc071',
      dark: '#ffb25e',
    },
    error: {
      xLight: red[50],
      main: red[500],
      dark: red[700],
    },
    success: {
      xLight: green[50],
      main: green[500],
      dark: green[700],
    },
  
  },

    contained: {
      color: '#ffffff',
  },

  shape: {
    borderRadius: 10,
  },

  typography: {
    fontFamily: "'Spartan', sans-serif",
    fontSize: 16,
    fontWeightLight: 300, // Roboto
    fontWeightRegular: 400, // Roboto
    fontWeightMedium: 700, // Roboto Condensed
    fontFamilySecondary: "'Roboto Condensed', sans-serif",
    
    body1: {
      lineHeight:1.8,
      fontWeight: 500,
      marginBottom: 16,
    },
    body2: {
      lineHeight: 1.8,
      fontSize: 16,
      fontWeight: 500,
    },

    subtitle2: {
      fontSize: 12,
      lineHeight:1.8,
      fontWeight: 500,

    },


    h1: {
        fontWeight: 900,
        textTransform: 'uppercase',
        marginBottom: 16,
        fontSize:52,
        [breakpoints.down('sm')]: {
          fontSize:32,
        },
      },
    h2: {
        fontWeight: 800,
        marginBottom: 16,
        textTransform: 'uppercase',
        fontSize:42,
        [breakpoints.down('sm')]: {
          fontSize:24,
        },
    },
    h3: {
        fontWeight: 800,
        marginBottom: 16,
        fontSize:32,
        lineHeight:1.4,
        [breakpoints.down('sm')]: {
          fontSize:20,
        },
    },
    subtitle1: {
        textTransform: 'uppercase',
        marginBottom: 16,
        fontSize: 16,
        letterSpacing:3,
        fontWeight: 900,
        [breakpoints.down('sm')]: {
          fontSize:12,
        },
    },
    h4: {
        fontWeight: 600,
        fontSize: 24,
        [breakpoints.down('sm')]: {
          fontWeight: 700,
          fontSize:18,
        },    
    },  

    h5: {
      fontWeight: 600,
      marginBottom: 16,
      fontSize: 18,
      [breakpoints.down('sm')]: {
        fontSize:16,
      },    
  },
  
  h6: {
    fontWeight: 600,
    fontSize: 16,
    [breakpoints.down('sm')]: {
      fontSize:15,
    },    
},



},

});

export default theme;

